module.exports = __webpack_public_path__ + "static/media/clock still 01.43a5d4eb.webp";